import { renderPlans } from 'sites/pivothealth.com/bridge-to-medicare/consumer/quotes/initDOM'
import { BTM } from 'core/constants/products'
import forEach from 'utils/DOM/forEach'

function offerBTM(store) {
  renderPlans(store, '#tiles-btm', 'template-tiles-btm')

  const btmIds = store.plansByType[BTM].reduce((accum, id) => {
    return `${accum ? `${accum},` : ''}${id}-364`
  }, null)

  forEach('.js-compare-btm-link', compareBtm => {
    compareBtm.search = `plans=${btmIds}`
  })
}

export default offerBTM
